module.exports = __webpack_public_path__ + "static/media/conference.d9425cd1.jpg";